import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import ViewportList from 'react-viewport-list';
import { useDispatch, useSelector } from 'react-redux';
import FieldListSearchTable from './FieldListSearchTable';
import { fetchRole } from '../../../../../redux/reducers/role';
import { ThemeContext } from '../../../../../themes/ThemeProvider';
import { Button, TextField, FormHelperText } from '@material-ui/core';
import React, { useEffect, useState, useContext, useRef } from 'react';
import { WarningSnackbar } from '../../../../../components/CustomSnackBar';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import { fetchUserDefinedWindows } from '../../../../../redux/reducers/EventTactics/EventTactics';
import {
  fetchCreatedByDropDownData,
  getAllReportCreatedForData,
} from '../../../../../redux/reducers/ReportMaster';
import {
  getBaseCategory,
  getFieldType,
  resetData,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {
  filteredCheckedData,
  filteredCheckedFieldTypeData,
  tempSelectFieldTypeFunc,
  tempSelectFunc,
} from '../../../../../util/Functions';
import {
  fetchExistingDataRepositoryNames,
  resetBaseRepositoryFieldsData,
  resetDataRepo,
  getDropDownData,
} from '../../../../../redux/reducers/GlobalField/DataRepository';

const SearchDataRepositories = ({
  setTabValue = () => {},
  setFieldListRowData,
  setUsageState = () => {},
  usageState,
  eventTrigger,
  setRowSelected,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  fieldList,
  setFieldList,
  isLoading,
  deleteSql,
  setRules,
  rules,
  isReportsFilter,
  isReports,
  sortFields,
  setSortFields,
  selectedRows,
  setFieldValue,
  setSelectedRows,
  isGlobalFieldList,
  resultExpCondition,
  reportFieldsDeleteIdsRef,
  workqueueFieldsDeletedIdsRef,
  isWorkQueue,
  sortFieldsDeleteIdsRef,
  resultRef,
  linkedCategory,
  filterValues,
  fieldsDeleteIdsRef,
  mapFields,
  handleClose,
  tempSelectedRows,
  setTempSelectedRows,
  setFormikFieldValue,
  setReportFieldValue,
  addAccountUpdate,
  setSelectedGlobalField,
  handleEventTacticSearch,
  workQueue,
  setInitialValues,
  filterMethodRef,
  handleDirty,
  setFormulaFields,
  formulaFields,
  setFilterFields,
  filterFields,
  isTriggers,
  isFormulaTrue,
  isDataManager,
  setDMFieldValue,
  dmValues,
  isDMRTrue,
  deletedProcessorFields,
  deletedSelectedFields,
  isDMTrue,
  deletedIds,
  setDeletedIds,
  dmRecordCategory,
  setIntermediateField,
  intermediateField,
  handleSelectTriggerField,
  selectedRepoField,
  setSelectedField,
  isLetterMaintenance,
  exceptionType,
  isDMFilter,
  dateStampFields,
  setDateStampFields,
  dateStampFieldDeleteRef,
  reportDateStamp,
  getFieldPosition = () => {},
  moduleName,
}) => {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({ fieldListCode: fieldList ? fieldList : '' });
  const [saveData, setSaveData] = useState(selectedRepoField ? selectedRepoField : []);
  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const { baseCategoryData, fieldListDataUsage, fieldTypeData } = useSelector(
    ({ addFieldList }) => addFieldList,
  );
  const [customError, setCustomError] = useState(false);
  const [usage, setUsage] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const { setSample } = useContext(SelectTabContextProvider);
  const { userDefinedFieldsData } = useSelector(({ addEventTactic }) => addEventTactic);
  const tempUnCheckedRef = useRef([]);
  const { basicInfoData, category } = useSelector(({ addRuleGroup }) => addRuleGroup);
  const ref = useRef(null);

  const { allRepositoryNames } = useSelector(({ dataRepository }) => dataRepository);

  useEffect(() => {
    dispatch(getFieldType());
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    dispatch(fetchUserDefinedWindows());
    dispatch(resetBaseRepositoryFieldsData());
  }, []);

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.fieldName === option) {
          label = item;
        }
      });
    return label;
  };
  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');
  const schema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const getCategoryObject = (value, data) => {
    const category = data && data?.filter((i) => i?.categoryCode === value);
    if (category?.length > 0) {
      return category[0];
    }
  };
  useEffect(() => {
    if (fieldList) {
      setSearchData({ ...searchData, fieldListCode: fieldList });
    }
  }, [fieldList]);

  useEffect(() => {
    if (category) {
      setSearchData({
        ...searchData,
        baseCategory: category ? getCategoryObject(category, filteredCategory) : {},
      });
    }
  }, [category]);

  // reset data and fetch Base Catagory dropdown data(2700799562)
  useEffect(() => {
    dispatch(resetDataRepo());
    dispatch(resetData());
    dispatch(getBaseCategory());
    dispatch(fetchRole());
    dispatch(fetchExistingDataRepositoryNames());
    if (!isReports && setRowSelected && setSample && setIsCopyData) {
      setRowSelected('');
      setSample(false);
      setIsCopyData(false);
    }
  }, []);

  // checking there is usage or not(2700799562)
  useEffect(() => {
    if (fieldListDataUsage?.userMetrix === 'No') {
      deleteUsage
        ? setUserMetrixDelete(false)
        : isDelete
          ? setCustomError(false)
          : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (fieldListDataUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !isDelete && !deleteUsage && setUsageState(true);
      !isDelete && !deleteUsage && setTabValue(2);
      setUserMetrixDelete(true);
    }
  }, [fieldListDataUsage]);

  // reset state(2700799562)
  useEffect(() => {
    if (!isReports) {
      setUsageState(false);
      setTabValue(0);
      setIsDelete(false);
    }
    setCustomError(false);
  }, []);
  const SearchSessionRepository = JSON.parse(sessionStorage.getItem('Repository'));
  useEffect(() => {
    setSelectedOption(SearchSessionRepository?.repoName);
  }, []);

  // form initialvalues(2700799562)
  const initialValues = {
    repoName: '',
    repoDescription: '',
    category: dmRecordCategory
      ? dmRecordCategory
      : isFormulaTrue
        ? getCategoryObject(basicInfoData?.category, baseCategoryData)
        : isLetterMaintenance
          ? ''
          : addAccountUpdate || isDMFilter || reportDateStamp
            ? { categoryCode: 'CO', categoryName: 'Core' }
            : '',
    tableName: '',
    fieldName: '',
    fieldType: reportDateStamp ? 'Date' : '',
    createdBy: '',
    createdDate: null,
    fieldDescription: '',
  };

  // set search Data(2700799562)
  const handleSubmit = (values) => {
    setSearchFlag(true);
    setSearchData(values);
    setSubmit(true);
    if (!addAccountUpdate) {
      sessionStorage.setItem('Repository', JSON.stringify(values));
    }
  };

  useEffect(() => {
    if (addAccountUpdate) {
      setSearchData({
        ...searchData,
        category: { categoryCode: 'CO', categoryName: 'Core' },
      });
    }
  }, [addAccountUpdate]);
  useEffect(() => {
    if (eventTrigger) {
      setSearchData({
        ...searchData,
        category: { categoryCode: 'CO', categoryName: 'Core' },
        repoType: { repoTypeCode: 'U', repoTypeName: 'USER' },
      });
    }
  }, [eventTrigger]);
  useEffect(() => {
    if (basicInfoData) {
      setSearchData({
        ...searchData,
        category: getCategoryObject(basicInfoData?.category, baseCategoryData),
      });
    }
  }, [basicInfoData]);
  useEffect(() => {
    setSearchData({
      ...searchData,
      category: linkedCategory || dmRecordCategory,
    });
  }, [isGlobalFieldList, linkedCategory, dmRecordCategory]);
  useEffect(() => {
    if (reportDateStamp) {
      setSearchData({
        ...searchData,
        category: { categoryCode: 'CO', categoryName: 'Core' },
        fieldType: 'Date',
      });
    }
  }, [reportDateStamp]);

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedByDropDownData('datarepository'));
  }, []);

  const getWindowNameData = () => {
    if (allRepositoryNames && allRepositoryNames?.length > 0 && nameData) {
      return allRepositoryNames?.filter((i) =>
        String(i?.repositoryName?.toLowerCase())?.includes(nameData?.toLowerCase()),
      );
    } else {
      return allRepositoryNames?.length > 0 ? allRepositoryNames : [];
    }
  };

  useEffect(() => {
    document.addEventListener('click', (e) => {
      if (!e?.target?.id || e?.target?.id !== 'repoNamePrompt') {
        setNamePopover(false);
      }
    });
    return () => {
      document.removeEventListener('click', () => {});
    };
  }, []);

  const keyPress = (e, setFieldValue) => {
    if (e.key === 'Enter') {
      setFieldValue(
        'repoName',
        // selectedOption ?
        //   selectedOption :
        //   getWindowNameData()[0]?.repositoryName ?
        //     getWindowNameData()[0]?.repositoryName :
        e.target.value,
      );
      setSelectedOption(e.target.value);
    }
  };

  return (
    // Removed Card styles for text fields (2700799562)
    <div className={`${isReports && !addAccountUpdate ? 'col-md-12' : ''}`}>
      <Formik
        onSubmit={handleSubmit}
        initialValues={
          SearchSessionRepository && !mapFields && !addAccountUpdate && !eventTrigger
            ? SearchSessionRepository
            : initialValues
        }
        enableReinitialize
        validationSchema={schema}
      >
        {(props) => {
          const { values, handleChange, handleBlur, setFieldValue, touched, errors, resetForm } =
            props;
          return (
            // Changes text field variant from outlined to standard (2700799562)
            <div>
              <Form autoComplete="off" noValidate>
                <ErrorBoundaryForComponents>
                  <div className="form-row autocomplete-field standard-field-textfields new-standard-textfields">
                    <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="category"
                        id="category"
                        size="small"
                        disabled={
                          category ||
                          addAccountUpdate ||
                          isFormulaTrue ||
                          dmRecordCategory ||
                          eventTrigger ||
                          isDMFilter ||
                          reportDateStamp
                        }
                        value={values.category}
                        options={filteredCategory}
                        autoHighlight
                        getOptionDisabled={(option) => option.categoryCode === ''}
                        getOptionLabel={(option) => {
                          return option && option.categoryName
                            ? option.categoryCode === null
                              ? option.categoryName
                              : option.categoryCode + ' - ' + option.categoryName
                            : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('category', value);
                        }}
                        placeholder="Select Category"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              // className={`${classes.labelName} ${classes.selectLabel}`}
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              name="category"
                              label="Category"
                              placeholder="Select Category"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                      <TextField
                        margin="dense"
                        id="repoNamePrompt"
                        className={` ${classes.labelName}`}
                        onClick={() => {
                          setNamePopover(!namePopover);
                        }}
                        // className={`${classes.labelName} ${classes.inputLabel}`}

                        variant="outlined"
                        placeholder={`Enter Repository Name`}
                        label="Repository Name"
                        name="repoName"
                        onKeyDown={(e) => keyPress(e, setFieldValue)}
                        value={values?.repoName}
                        onChange={(e) => {
                          setNamePopover(true);
                          setFieldValue('repoName', e?.target?.value);
                          if (e.target.value) {
                            setNameData(e?.target?.value);
                          } else if (e.target.value === '') {
                            setNameData('');
                            setSelectedOption('');
                          }
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.repoName}
                        error={Boolean(touched.repoName && errors.repoName)}
                      />
                      <FormHelperText>
                        {touched.repoName && errors.repoName && errors.repoName}
                      </FormHelperText>
                      {namePopover && getWindowNameData()?.length > 0 && (
                        <div
                          ref={ref}
                          className={`global-field-popover Add-trigger-group-popover data-repo-popover-width ${
                            namePopover ? 'popover-open' : ''
                          }`}
                        >
                          {
                            <ViewportList
                              viewportRef={ref}
                              items={getWindowNameData()}
                              itemMinSize={10}
                            >
                              {(item) => (
                                <div className="data-repo-popover" key={item?.repositoryName}>
                                  <p
                                    className={`${
                                      selectedOption === item?.repositoryName
                                        ? 'selected-dropdown-option'
                                        : ''
                                    }`}
                                    onClick={() => {
                                      setFieldValue('repoName', item?.repositoryName);
                                      setSelectedOption(item?.repositoryName);
                                    }}
                                  >
                                    {item?.repositoryName?.replace(/ /g, '\u00a0')}
                                  </p>
                                </div>
                              )}
                            </ViewportList>
                          }
                        </div>
                      )}
                    </div>
                    <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                      <TextField
                        margin="dense"
                        // className={`${classes.labelName} ${classes.inputLabel}`}
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder="Enter Repository Description"
                        label="Repository Description"
                        name="repoDescription"
                        value={values.repoDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>
                    <div
                      className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3   ${
                        isGlobalFieldList ? 3 : 3
                      } form-group`}
                    >
                      <TextField
                        margin="dense"
                        // className={`${classes.labelName} ${classes.inputLabel}`}
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Enter Field Name`}
                        label="Field Name"
                        name="fieldName"
                        value={values?.fieldName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.fieldName}
                        error={Boolean(touched.fieldName && errors.fieldName)}
                      />
                      <FormHelperText>
                        {touched.fieldName && errors.fieldName && errors.fieldName}
                      </FormHelperText>
                    </div>
                    <div
                      className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3   ${
                        isGlobalFieldList ? 3 : 3
                      } form-group`}
                    >
                      <TextField
                        margin="dense"
                        // className={`${classes.labelName} ${classes.inputLabel}`}
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Enter Field Description`}
                        label="Field Description"
                        name="fieldDescription"
                        value={values?.fieldDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.fieldDescription}
                      />
                    </div>
                    {isReports ? (
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="fieldType"
                          id="fieldType"
                          size="small"
                          value={values.fieldType}
                          disabled={reportDateStamp}
                          options={fieldTypeData || []}
                          autoHighlight
                          // getOptionDisabled={(option) => option.categoryCode === ""}
                          getOptionLabel={(option) => {
                            return option ? option : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('fieldType', value);
                          }}
                          placeholder="Select Field Type"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                // className={`${classes.labelName} ${classes.selectLabel}`}
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                name="fieldType"
                                label="Field Type"
                                placeholder="Select Field Type"
                              />
                            </div>
                          )}
                        />
                      </div>
                    ) : null}
                    {!mapFields ? (
                      <div
                        className={
                          isReports
                            ? 'col-md-4 col-lg-12 col-xl-12 form-group'
                            : 'col-md-4 col-lg-3 col-xl-3 form-group'
                        }
                      >
                        <div
                          className={
                            isReports
                              ? 'd-flex justify-content-xl-center justify-content-lg-center justify-content-md-center'
                              : 'd-flex justify-content-xl-start justify-content-lg-center justify-content-md-center'
                          }
                        >
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              setSearchData(initialValues);
                              setSubmit(true);
                              resetForm(initialValues);
                              setNameData('');
                              setSelectedOption('');
                              sessionStorage.removeItem('Repository');
                              intermediateField?.fieldName &&
                                setTempSelectedRows([{ ...intermediateField }]);
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`ml-1 search-btn ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {mapFields ? (
                    <div className="form-row new-standard-textfields">
                      <div className="col-md-7 col-lg-7 col-xl-7 mb-3">
                        <div className="d-flex  justify-content-end">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              setSearchData(initialValues);
                              setSubmit(true);
                              resetForm(initialValues);
                              setNameData('');
                              setSelectedOption('');
                              sessionStorage.removeItem('Repository');
                              intermediateField?.fieldName &&
                                setTempSelectedRows([{ ...intermediateField }]);
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`ml-1 search-btn ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                      <div className={`col-md-5 col-lg-5 col-xl-5 mb-3`}>
                        <div className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-end">
                          <Button
                            aria-label="close"
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              handleClose();
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            aria-label="save"
                            variant="outlined"
                            className={`ml-1 search-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              const obj = tempSelectFunc(
                                'repositoryName',
                                'fieldName',
                                tempUnCheckedRef,
                              );
                              if (setIntermediateField) {
                                setIntermediateField('field', tempSelectedRows[0]);
                                setIntermediateField(
                                  'newFieldName',
                                  tempSelectedRows[0]?.fieldName,
                                );
                              }
                              if (setFormulaFields) {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  formulaFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                const formula = [
                                  ...deletedIds,
                                  newUnSelectedRows?.length > 0
                                    ? newUnSelectedRows[0]?.formulaFieldMapId
                                    : 0,
                                ];
                                setDeletedIds(formula);
                                setFormulaFields(allSelectedRows);
                              }
                              if (setFilterFields) {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  filterFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                const filter = [
                                  ...deletedIds,
                                  newUnSelectedRows?.length > 0
                                    ? newUnSelectedRows[0]?.formulaFieldMapId
                                    : 0,
                                ];
                                setDeletedIds(filter);
                                setFilterFields(allSelectedRows);
                              }
                              if (setSelectedRows) {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  selectedRows,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                if (
                                  !isGlobalFieldList &&
                                  !isTriggers &&
                                  !isDataManager &&
                                  !isDMRTrue &&
                                  !isDMTrue &&
                                  !isLetterMaintenance
                                ) {
                                  tempSelectedRows.forEach((el) => {
                                    setReportFieldValue(
                                      'fieldHeader' + el.fieldName + el.repositoryName,
                                      el.fieldLabel,
                                    );
                                    setReportFieldValue(
                                      'printSubTotal' + el.fieldName + el.repositoryName,
                                      'N',
                                    );
                                  });
                                  if (!isWorkQueue) {
                                    reportFieldsDeleteIdsRef.current = [
                                      ...reportFieldsDeleteIdsRef.current,
                                      newUnSelectedRows?.length > 0
                                        ? newUnSelectedRows[0]?.reportFieldId
                                        : 0,
                                    ];
                                  }

                                  if (isWorkQueue) {
                                    workqueueFieldsDeletedIdsRef.current = [
                                      ...workqueueFieldsDeletedIdsRef?.current,
                                      newUnSelectedRows?.length > 0
                                        ? newUnSelectedRows[0]?.workqueueFieldId
                                        : 0,
                                    ];
                                  }
                                }

                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                if (isGlobalFieldList) {
                                  const arr = allSelectedRows.map((ele) => ele.category);
                                  const uniqueData = new Set(arr);
                                  if (setFormikFieldValue) {
                                    setFormikFieldValue('otherCategory', [
                                      ...Array.from(uniqueData),
                                    ]);
                                  }
                                  if (newUnSelectedRows.length > 0) {
                                    const allDeleteSortIds = [];
                                    newUnSelectedRows.forEach((el) => {
                                      if (el.fieldListFieldId) {
                                        allDeleteSortIds.push(el.fieldListFieldId);
                                      }
                                    });
                                    if (allDeleteSortIds.length > 0) {
                                      fieldsDeleteIdsRef.current = [
                                        ...fieldsDeleteIdsRef.current,
                                        ...allDeleteSortIds,
                                      ];
                                    } else {
                                      fieldsDeleteIdsRef.current = [
                                        ...fieldsDeleteIdsRef.current,
                                        0,
                                      ];
                                    }
                                  }
                                }
                                if (isTriggers) {
                                  fieldsDeleteIdsRef.current = [
                                    ...fieldsDeleteIdsRef.current,
                                    newUnSelectedRows?.length > 0
                                      ? newUnSelectedRows[0]?.formulaFieldMapId
                                      : 0,
                                  ];
                                }

                                if (isDMTrue) {
                                  if (newUnSelectedRows.length > 0) {
                                    const allDeleteIds = [];
                                    newUnSelectedRows.forEach((el) => {
                                      if (el.dataManagerRecordId) {
                                        allDeleteIds.push(el.dataManagerRecordId);
                                      }
                                    });
                                    if (allDeleteIds.length > 0) {
                                      deletedSelectedFields.current = [
                                        ...deletedSelectedFields.current,
                                        ...allDeleteIds,
                                      ];
                                    } else {
                                      deletedSelectedFields.current = [
                                        ...deletedSelectedFields.current,
                                        0,
                                      ];
                                    }
                                  }
                                }
                                setSelectedRows(allSelectedRows);
                              }
                              if (isDMRTrue && dmValues) {
                                const fieldTypeObj = tempSelectFieldTypeFunc(
                                  'repositoryName',
                                  'fieldName',
                                  'processorFieldType',
                                  tempUnCheckedRef,
                                );
                                const [newSelectedRows, newUnSelectedRows] =
                                  filteredCheckedFieldTypeData(
                                    dmValues.selectedFields,
                                    fieldTypeObj,
                                    'repositoryName',
                                    'fieldName',
                                    'processorFieldType',
                                  );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                setDMFieldValue('selectedFields', allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.processorId) {
                                      allDeleteIds.push(el.processorId);
                                    }
                                  });
                                  if (allDeleteIds.length > 0) {
                                    deletedProcessorFields.current = [
                                      ...deletedProcessorFields.current,
                                      ...allDeleteIds,
                                    ];
                                  } else {
                                    deletedProcessorFields.current = [
                                      ...deletedProcessorFields.current,
                                      0,
                                    ];
                                  }
                                }
                              }
                              if (isDataManager && dmValues) {
                                const fieldTypeObj = tempSelectFieldTypeFunc(
                                  'repositoryName',
                                  'fieldName',
                                  'mapFieldType',
                                  tempUnCheckedRef,
                                );
                                const [newSelectedRows, newUnSelectedRows] =
                                  filteredCheckedFieldTypeData(
                                    dmValues.selectedFields,
                                    fieldTypeObj,
                                    'repositoryName',
                                    'fieldName',
                                    'mapFieldType',
                                  );
                                const position = getFieldPosition(dmValues);
                                const newTempRows = tempSelectedRows.map((item, i) => {
                                  return {
                                    ...item,
                                    fieldPosition: position + i,
                                  };
                                });
                                const allSelectedRows = [...newSelectedRows, ...newTempRows];
                                setDMFieldValue('selectedFields', allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.dataManagerRecordFieldId) {
                                      allDeleteIds.push(el.dataManagerRecordFieldId);
                                    }
                                  });

                                  const ids = [...deletedIds, ...allDeleteIds];
                                  setDeletedIds(ids);
                                }
                              }
                              if (isLetterMaintenance && dmValues) {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  dmValues?.selectedFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                setDMFieldValue('selectedFields', allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.letterFieldId) {
                                      allDeleteIds.push(el.letterFieldId);
                                    }
                                  });

                                  const ids = [...deletedIds, ...allDeleteIds];
                                  setDeletedIds(ids);
                                }
                              }
                              if (setSortFields) {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  sortFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteSortIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.reportSortFieldsId) {
                                      allDeleteSortIds.push(el);
                                    }
                                    if (el?.workqueueSortFieldId) {
                                      allDeleteSortIds.push(el);
                                    }
                                  });
                                  if (allDeleteSortIds.length > 0) {
                                    sortFieldsDeleteIdsRef.current = [
                                      ...sortFieldsDeleteIdsRef.current,
                                      ...allDeleteSortIds,
                                    ];
                                  } else {
                                    sortFieldsDeleteIdsRef.current = [
                                      ...sortFieldsDeleteIdsRef.current,
                                      0,
                                    ];
                                  }
                                }
                                setSortFields([...newSelectedRows, ...tempSelectedRows]);
                              }
                              if (setDateStampFields) {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  dateStampFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteDateStampIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.reportDateStampId) {
                                      allDeleteDateStampIds.push(el);
                                    }
                                  });
                                  if (allDeleteDateStampIds.length > 0) {
                                    dateStampFieldDeleteRef.current = [
                                      ...dateStampFieldDeleteRef.current,
                                      ...allDeleteDateStampIds,
                                    ];
                                  } else {
                                    dateStampFieldDeleteRef.current = [
                                      ...dateStampFieldDeleteRef.current,
                                      0,
                                    ];
                                  }
                                }
                                setDateStampFields([...newSelectedRows, ...tempSelectedRows]);
                              }
                              if (setRules) {
                                const newArr = [];

                                tempSelectedRows.forEach((row, i) => {
                                  const obj = {
                                    field: {
                                      ...row,
                                      dataType: row.fieldType,
                                      globalField: row.tableColumnName,
                                    },
                                    condition: '',
                                    value: '',
                                    sqlValue: '',
                                    value1: '',
                                    ruleCode: '',
                                    ...row,
                                  };
                                  if (rules?.length === 0) {
                                    obj.ruleCode = 'S' + (i + 1);
                                  } else {
                                    const lastRuleCodeNum = Number(
                                      rules[rules.length - 1].ruleCode.slice(1),
                                    );
                                    obj.ruleCode = 'S' + (lastRuleCodeNum + i + 1);
                                  }
                                  // obj.ruleCode =
                                  //   copyArr.length > 0
                                  //     ? "S" +
                                  //       (Number(copyArr[copyArr.length - 1].ruleCode.slice(1)) + 1)
                                  //     : "S1";
                                  newArr.push(obj);
                                });

                                //             obj.ruleCode =
                                //   copyArr.length > 0
                                //     ? "S" + (Number(copyArr[copyArr.length - 1].ruleCode.slice(1)) + 1)
                                //     : "S1";
                                // copyArr.push(obj);

                                if (newArr.length > 0) {
                                  const result = [...rules, ...newArr].map((el, i) => el.ruleCode);
                                  setFieldValue(
                                    'sqlExpression',
                                    result.join(` ${resultExpCondition} `),
                                  );

                                  setInitialValues((prev) => {
                                    return {
                                      ...prev,
                                      sqlRules: [...rules, ...newArr],
                                      sqlExpression: result.join(` ${resultExpCondition} `),
                                      accessMethod: filterMethodRef.current
                                        ? filterMethodRef.current
                                        : '',
                                      disposition: filterValues?.disposition
                                        ? filterValues?.disposition
                                        : [],
                                      collectors: filterValues?.collectors
                                        ? filterValues?.collectors
                                        : [],
                                      repoitoryName: filterValues?.repoitoryName
                                        ? filterValues?.repoitoryName
                                        : '',
                                      fieldsName: filterValues?.fieldsName
                                        ? getObject(
                                          filterValues?.fieldsName?.fieldName,
                                          userDefinedFieldsData,
                                        )
                                        : '',
                                      values: filterValues?.values ? filterValues?.values : [],
                                      client: filterValues?.client ? filterValues?.client : [],
                                      phase: filterValues?.phase ? filterValues?.phase : [],
                                      Date: filterValues?.Date ? filterValues?.Date : '',
                                      lastDate: filterValues?.lastDate
                                        ? filterValues?.lastDate
                                        : '',
                                      startDate: filterValues?.startDate
                                        ? filterValues?.startDate
                                        : '',
                                      action: filterValues?.action ? filterValues?.action : '',
                                      fromValues: filterValues?.fromValues
                                        ? filterValues?.fromValues
                                        : '',
                                      toValues: filterValues?.toValues
                                        ? filterValues?.toValues
                                        : '',
                                    };
                                  });
                                }
                                // setRules();
                              }
                              if (handleDirty) {
                                handleDirty(true, 'fixed');
                              }
                              setTempSelectedRows && setTempSelectedRows([]);
                              setSelectedField && setSelectedField(saveData);
                              handleClose();
                            }}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </ErrorBoundaryForComponents>
              </Form>
            </div>
          );
        }}
      </Formik>
      <FieldListSearchTable
        searchData={searchData}
        setTabValue={setTabValue}
        searchFlag={searchFlag}
        submit={submit}
        setSubmit={setSubmit}
        setUsage={setUsage}
        usage={usage}
        setFieldListRowData={setFieldListRowData}
        setDeleteUsage={setDeleteUsage}
        setIsDelete={setIsDelete}
        isDelete={isDelete}
        setUsageState={setUsageState}
        usageState={usageState}
        userMetrixDelete={userMetrixDelete}
        setIsUsage={setIsUsage}
        isUsage={isUsage}
        setRowSelected={setRowSelected}
        setUserMetrixDelete={setUserMetrixDelete}
        setIsCopyData={setIsCopyData}
        StepperFieldList={StepperFieldList}
        setShowSearch={setShowSearch}
        setFieldListCode={setFieldListCode}
        setFieldList={setFieldList}
        fieldList={fieldList}
        isReportLoader={isLoading}
        deleteSql={deleteSql}
        isReports={isReports}
        isReportsFilter={isReportsFilter}
        sortFields={sortFields}
        setSortFields={setSortFields}
        selectedRows={selectedRows}
        setFieldValue={setFieldValue}
        setSelectedRows={setSelectedRows}
        isGlobalFieldList={isGlobalFieldList}
        resultExpCondition={resultExpCondition}
        resultRef={resultRef}
        reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
        sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
        linkedCategory={linkedCategory}
        values={filterValues}
        fieldsDeleteIdsRef={fieldsDeleteIdsRef}
        tempSelectedRows={tempSelectedRows}
        setTempSelectedRows={setTempSelectedRows}
        tempUnCheckedRef={tempUnCheckedRef}
        addAccountUpdate={addAccountUpdate}
        setSelectedGlobalField={setSelectedGlobalField}
        handleEventTacticSearch={handleEventTacticSearch}
        workQueue={workQueue}
        mapFields={mapFields}
        setFormulaFields={setFormulaFields}
        formulaFields={formulaFields}
        setFilterFields={setFilterFields}
        filterFields={filterFields}
        isTriggers={isTriggers}
        isDataManager={isDataManager}
        dmValues={dmValues}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        isDMRTrue={isDMRTrue}
        setIntermediateField={setIntermediateField}
        intermediateField={intermediateField}
        handleSelectTriggerField={handleSelectTriggerField}
        eventTrigger={eventTrigger}
        setSaveData={setSaveData}
        saveData={saveData}
        selectedRepoField={selectedRepoField}
        setSelectedField={setSelectedField}
        isFormulaTrue={isFormulaTrue}
        isDMTrue={isDMTrue}
        isLetterMaintenance={isLetterMaintenance}
        exceptionType={exceptionType}
        isDMFilter={isDMFilter}
        setDateStampFields={setDateStampFields}
        dateStampFields={dateStampFields}
        reportDateStamp={reportDateStamp}
        moduleName={moduleName}
      />
      {customError && <WarningSnackbar errorMsg={'This Field List is not being used anywhere'} />}
    </div>
  );
};

export default React.memo(SearchDataRepositories);
